import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {SearchHandlerService} from '../../search-handler.service';
import {StoredSearchServiceImplementation, StoredSearchService} from '../../stored-search.service';
import {SearchContainer} from '../../../core/definitions/search-container';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-search-stored-search-menu',
    templateUrl: './stored-search-menu.component.html',
    styleUrls: ['./stored-search-menu.component.scss'],
    standalone: false
})
export class StoredSearchMenuComponent implements OnInit, OnDestroy {
  // Injections
  private readonly searchHandler: SearchHandlerService = inject(SearchHandlerService);
  private readonly storedSearchService: StoredSearchService = inject(StoredSearchService);

  @Input() searchContainer: SearchContainer;

  storedSearchButtonDropdown = false;
  showStoredSearchPanel = false;
  fsi: StoredSearchServiceImplementation;

  private readonly subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    this.fsi = this.storedSearchService.createFSI(this.searchContainer);
    this.subscriptions.push(this.storedSearchService.openStoredSearchEditPanel$.subscribe(() => {
      this.showStoredSearchPanel = true;
    }));
  }


  hasChanges() {
    return this.fsi.storedSearchHasChanges(this.searchContainer.storedSearch.curStoredSearch);
  }

  toggleStoredSearchPanel() {
    this.showStoredSearchPanel = !this.showStoredSearchPanel;
  }

  toggleStoredSearchButtonDropDown() {
    this.storedSearchButtonDropdown = !this.storedSearchButtonDropdown;
  }

  async deselectStoredSearch() {
    if (this.searchContainer.storedSearch.curStoredSearch) {
      this.searchContainer.storedSearch.curStoredSearch = null;
      this.searchContainer.storedSearch.curStoredSearchId = null;
      this.searchContainer.storedSearch.curStoredSearchName = null;
      await this.searchHandler.goPathView(this.searchContainer.path, this.searchContainer);
    }
  }













}
